import { render, staticRenderFns } from "./CzPills.vue?vue&type=template&id=c491d170&scoped=true&"
import script from "./CzPills.vue?vue&type=script&lang=ts&"
export * from "./CzPills.vue?vue&type=script&lang=ts&"
import style0 from "./CzPills.vue?vue&type=style&index=0&id=c491d170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c491d170",
  null
  
)

export default component.exports